import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const collapsibleSidebarFn = /* @__PURE__ */ createRecipe('collapsible-sidebar', {
  "showAsOverlay": false,
  "open": true
}, [
  {
    "showAsOverlay": false,
    "open": true,
    "css": {
      "position": "relative"
    }
  },
  {
    "showAsOverlay": false,
    "open": false,
    "css": {
      "position": "fixed"
    }
  }
])

const collapsibleSidebarVariantMap = {
  "showAsOverlay": [
    "true"
  ],
  "open": [
    "true",
    "false"
  ]
}

const collapsibleSidebarVariantKeys = Object.keys(collapsibleSidebarVariantMap)

export const collapsibleSidebar = /* @__PURE__ */ Object.assign(memo(collapsibleSidebarFn.recipeFn), {
  __recipe__: true,
  __name__: 'collapsibleSidebar',
  __getCompoundVariantCss__: collapsibleSidebarFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: collapsibleSidebarVariantKeys,
  variantMap: collapsibleSidebarVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, collapsibleSidebarVariantKeys)
  },
  getVariantProps: collapsibleSidebarFn.getVariantProps,
})